import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
import { openLink } from '../utils';

export const handleNavigationRequests = (bootstrapperFeatures) => {
  const accountActions = bootstrapperFeatures['account-actions'];
  if (!accountActions) {
    return;
  }
  accountActions.onActionRequested(({ actionId, data }) => {
    if (actionId === ACCOUNT_ACTION_IDS.NAVIGATE_TO) {
      openLink(data);
    }
  });
};
